import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateEntraAppRequest, EntraApp, EntraAppResponse, SetEntraAppSecretRequest, UpdateEntraAppRequest } from '@models/csp';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class EntraAppsService {
  private readonly url = `${environment.bffUrl}/csp/entra-apps`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<EntraApp[]> {
    return this.http.get<EntraAppResponse[]>(this.url);
  }

  add(request: CreateEntraAppRequest): Observable<EntraApp> {
    return this.http.post<EntraAppResponse>(this.url, request);
  }

  update(id: string, request: UpdateEntraAppRequest): Observable<EntraApp> {
    return this.http.put<EntraAppResponse>(`${this.url}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }

  setSecret(id: string, request: SetEntraAppSecretRequest): Observable<EntraApp> {
    return this.http.post<EntraAppResponse>(`${this.url}/${id}/set-secret`, request);
  }
}
